import moment from "moment";
import { AuditTrailReadModel, CustomerAnalysis, InvoiceState, TotalInvoiceAmounts } from "../GeneratedClients/FreeBillApi";

export const totalInvoiceAmountsFakeData: () => TotalInvoiceAmounts = () => {
  
  const totalInvoices = Math.ceil(Math.random() * 201)
  const totalTaxAmount = Math.random() * 2022
  const totalNetAmount = Math.random() * 20202
  const totalGrossAmount = totalNetAmount + totalTaxAmount
  return {
    totalInvoices: totalInvoices,
    totalTaxAmount: totalTaxAmount,
    totalNetAmount: totalNetAmount,
    totalGrossAmount: totalGrossAmount
  }
}

export const totalInvoiceAmountsMonthlyFakeData: (periodInMonthes: number) => TotalInvoiceAmounts[] = (periodInMonthes) => {
  var actualMoment = moment().add(1, "month")
  const fakeList: TotalInvoiceAmounts[] = []
  
  for (let index = 0; index <= periodInMonthes; index++) {
    actualMoment = actualMoment.subtract(1, "month")
    const paid = Math.random() * 2020
    const pending = Math.random() * 2020
    const pastDue = Math.random() * 2020
    const sum = paid + pending + pastDue
    fakeList.unshift({
      month: actualMoment.month() + 1,
      year: actualMoment.year(),
      totalAmountCategories: [
        {
          name: InvoiceState.Paid,
          totalNetAmount: paid
        },
        {
          name: InvoiceState.Pending,
          totalNetAmount: pending
        },
        {
          name: InvoiceState.PastDue,
          totalNetAmount: pastDue
        },
      ],
      totalNetAmount: sum 
    })
  }
  return fakeList
} 

export const customerAnalysisFakeData: () => CustomerAnalysis[] = () => {
  var fakeList: CustomerAnalysis[] = []
  var fakeNames = ["Muster GmbH", "Müller & Sohn GmbH", "Mayer Consultants AG", "Malerbetrieb Schneider", "Schaller Logistik"]
  for (let index = 0; index < 5; index++) {
    var totalNetAmount = Math.random() * 1000
    var totalInvoices = Math.ceil(Math.random() * 100)
    fakeList.push({
      customerName: fakeNames[index],
      totalNetAmount: totalNetAmount,
      totalInvoices: totalInvoices
    })
  }
  return fakeList.sort((a, b) => (b.totalNetAmount! - a.totalNetAmount!))
} 

export const auditTrailsFakeData: () => AuditTrailReadModel[] = () => {
  var actualMoment = moment()
  var events = ["InvoiceCreated", "InvoiceSent", "InvoiceCanceled"]
  var fakeList: AuditTrailReadModel[] = []
  for (let index = 0; index < 10; index++) {
    actualMoment = actualMoment.subtract(Math.floor(Math.random()*20), "hour")
    fakeList.push({
      eventOccuredAt: actualMoment.toISOString(),
      eventName: events[Math.floor(Math.random()*events.length)],
    })
  }
  return fakeList
} 